import { SearchInput } from 'V2Components'
import { Typography } from 'procyon-ui'
import React from 'react'

function Header({ searchKey, setSearchKey }) {
  return (
    <div className='flex justify-between items-center'>
      <Typography variant='h3'>User Groups</Typography>
      <div className='flex gap-4'>
        <SearchInput sx={{ width: '280px' }} searchKey={searchKey} onChange={setSearchKey} />
        {/* <Button id='groups-add-btn' onClick={onAddClick} icon={faPlus} size='md' variant='primary'>
          Add
        </Button> */}
      </div>
    </div>
  )
}

export { Header }
